import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { InputGroupAddon, InputGroup, Input } from 'reactstrap'

const SurveyTemplateSearch = ({ handleSearch, searchText }) => {
  return (
    <InputGroup>
      <input
        name="template_search"
        className="form-control search-text"
        placeholder="Enter search keyword"
        value={searchText}
        onChange={handleSearch}
      />
      <InputGroupAddon className="btn-search">
          <FontAwesomeIcon icon="search" />
          Search
      </InputGroupAddon>
    </InputGroup>
  );
};

SurveyTemplateSearch.propTypes = {
  handleSearch: PropTypes.func,
  searchText: PropTypes.string
};

export default SurveyTemplateSearch;



// WEBPACK FOOTER //
// ./src/components/survey-templates/SurveyTemplateSearch.js